import { forwardRef } from 'react';

import { cn } from '@/lib/utils/cn';

const Progress = forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement> & {
    value?: number;
    max?: number;
  }
>(({ className, value = 0, max = 100, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      'relative h-2 w-full overflow-hidden rounded-full bg-primary',
      className
    )}
    {...props}
  >
    <div
      className="h-full w-full flex-1 bg-secondary transition-all"
      style={{ transform: `translateX(-${(value / max) * 100}%)` }}
    />
  </div>
));
Progress.displayName = 'Progress';

export { Progress };
